import React from 'react';
import { Field, reduxForm } from 'redux-form';

import PropTypes from 'prop-types';
import renderSelectField from './form/Select';
import renderSelectFieldKW from './form/SelectKW';

const SelectDropdown2 = ({ handleSubmit, title, items, renderKW }) => (
  <form className="form" onSubmit={handleSubmit}>
    <div className="form__form-group">
      <span className="form__form-group-label">{title}</span>
      <div className="form__form-group-field">
        <Field
          name="selected_dropdown_2"
          component={renderKW ? renderSelectFieldKW : renderSelectField}
          type="text"
          options={items}
        />
      </div>
    </div>
  </form>
);

SelectDropdown2.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  renderKW: PropTypes.bool,
};

SelectDropdown2.defaultProps = {
  renderKW: false,
};

export default reduxForm({
  form: 'select_dropdown_2', // a unique identifier for this form
  onChange: (values, dispatch, props) => {
    props.submit();
  },
  // initialValues: { selected_date: new Date(Date.now()).toLocaleString('d MMMM, yyyy') },
})(SelectDropdown2);
